<!--  -->
<template>
  <div class="cp_flow" :style="setBackColor">
    <Header />
    <div class="flow">
      <div class="flow__banner">
        <div class="flow__banner__cen">
          <img class="flow__banner__img" :src="`https://cdn.xiaohoucode.com/${this.certificateInfo.bgUrl}`" alt="">
          <div class="flow__banner__content">
            <a href="javascript:;" class="back" :style="setBgBtnColor" @click="goBack">
              <img src="@/assets/back.png" alt="" width="19" height="15">
              <span class="back_text">返回</span> 
            </a>
          </div>
        </div>
      </div>
      <div class="flow__main">
        <div class="flow__main__content">
          <CpSteps class="flow__steps" direction="vertical">
            <CpStep
              :color='globalConfig.main'
              :bgColor='globalConfig.main'
              v-for="(item, index) in process"
              :key="index"
              :isLast="index === process.length - 1"
              :list="process"
            >
              <div class="process_name" :style="setColorStyle">{{ setProcessName(item.processName) }}</div>
              <div class="step__desc" slot="desc">
                <div class="step__desc__left" :style="setColorStyle">{{ item.tipMsg }}</div>
                <div class="step__desc__addon">
                  <a 
                  v-if="isShowInfo && item.isShowInfo"
                  href="javascript:;" 
                  class="step__desc__button"
                  :style="setBgBtnColor"
                  @click="isShowEditUserInfo()"
                  >
                  查看报名信息
                  </a>
                  <a 
                  v-if="item.ticketContent"
                  href="javascript:;" 
                  class="step__desc__button ticket__btn"
                  :class="{'ticket__loading':item.ticketContent.isLoading}"
                  :style="setBgBtnColor"
                  @click="handleTicketBtn(item.ticketContent,item.processId)"
                  >
                  <Loading :main='globalConfig.main' v-if='item.ticketContent.isLoading' />
                  下载活动证明
                  </a>
                  <div class="certificate__content" 
                    @mouseenter="toggleTip(item.certificateContent,true)"
                    @mouseleave="toggleTip(item.certificateContent,false)"
                    >
                    <a 
                      v-if="item.certificateContent"
                      href="javascript:;" 
                      class="step__desc__button certificate"
                      :class="{'certificate__loading':item.certificateContent.isLoading}"
                      :style="setBgBtnColor"
                      @click="handleCertBtn(item.certificateContent,item.processId)"
                      >
                      <Loading :main='globalConfig.main' v-if='item.certificateContent.isLoading' />
                      下载证书
                    </a>
                    <div class="tip" v-show="item.certificateContent && item.certificateContent.isTip">
                      <span class="tip__arrow"></span>
                      <p class="tip__text">为保证证书下载的清晰度，建议使用<br />1920*1080及以上分辨率的电脑进行下载。</p>
                    </div>
                  </div>
                </div>
              </div>
            </CpStep>
          </CpSteps>
        </div>
      </div>
      <Certificate
        v-if="toggleCertificate"
        ref="certificate"
        class="certs"
        :no="currentCertificateContent.certificateNo"
        :city="currentCertificateContent.city"
        :winner="currentCertificateContent.studentName"
        :cpName="currentCertificateContent.competitionName"
        :cpStep="currentCertificateContent.competitionItemName"
        :prize="currentCertificateContent.awardName"
        :note="currentCertificateContent.extra"
        :bgImage="currentCertificateContent.bgImageUrl"
      />
      <CertificateNew
        v-else
        ref="certificate"
        class="certs"
        :no="currentCertificateContent.certificateNo"
        :city="currentCertificateContent.city"
        :winner="currentCertificateContent.studentName"
        :cpName="currentCertificateContent.competitionName"
        :cpStep="currentCertificateContent.competitionItemName"
        :prize="currentCertificateContent.awardName"
        :note="currentCertificateContent.extra"
        :bgImage="currentCertificateContent.bgImageUrl"
      />
      <Ticket
        ref="ticket"
        class="ticket"
        :bgImage='currentTicketConent.bgImageUrl'
        :ticketName="currentTicketConent.ticketName"
        :ticketNote="currentTicketConent.notice"
        :ticketItems="currentTicketConent.ticketItems"
      />
    </div>
    <!-- <AgreementSend
      v-show="isShowSend"
      :active='isShowSend'
      @close='close'
      @onSuccess='onSuccess'
    ></AgreementSend> -->
    <transition name="fade">
    <div class="dialog" v-if="dialogVisible">
      <div class="dialog_content">
        <div class="dialog_content_reg">
          <CpLogin
            :showList="showList"
            :groups='groups'
            :requiredList="requiredList"
            :showExtItems="showExtItems"
            :requiredExtItems="requiredExtItems"
            :currentUserInfo='currentUserInfo'
            @regSucces="regSucces"
            @regClose="regClose"
            @registClose='registClose'
            :competitionId="id"
            :isReview="true"
            bgUrl="#fff"
            show="reg"
            :loginType='loginType'
            userType='watch'
            :color='globalConfig.vice'
            :isInfoEdit='isInfoEdit'
          />
        </div>
      </div>
  </div>
    </transition>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { mapState,mapActions,mapGetters } from 'vuex';
import { getCpProcess,getStudentInfo,updateStudentInfo,getRegInfo,getPdfDownload,getPdfTicketDownload } from '../services/user';
import CertificateNew from '../components/CertificateNew.vue';
import Certificate from '../components/Certificate.vue'
import Ticket from '../components/Ticket.vue';
import Header from '@/components/Header'
// import AgreementSend from '@/components/agreementSend.vue'
import Loading from '@/components/Loading.vue'
import { download } from '@/utils/pdfDownload.js'

const downLoadTimer = 1615651200000; //2021-03-14
// const downLoadTimer = 1614528000000;  //2021-03-01
// const downLoadTickeTimer = 1621440000000; //2021-05-20
const downLoadTickeTimer = 1624982400000; //2021-06-30
import { errorHandler } from '@/utils/errorHandler';

export default {
  components: {
    CertificateNew,
    Certificate,
    Ticket,
    Header,
    // AgreementSend,
    Loading
  },

  data () {
    return {
      process: [],
      currentTicketConent: {},
      currentCertificateContent: {},
      currentUserInfo:{},
      dialogVisible:false,
      regInfo:{},
      isShowInfo:false,
      currentName:'',
      isInfoEdit:0
    };
  },

  computed:{
    ...mapState({
      id: state => state.router.id,
      isShowSend:state => state.user.isShowSend,
      certificateInfo: state=>state.certificate.info,
      globalConfig: state => state.router.globalConfig,
      loginType:state=>state.router.loginType,
      userInfo:state=>state.user.userInfo,
      websiteTime: state=>state.router.websiteTime
    }),
    ...mapGetters([
        'loginStatus',
        'tokenKey'
    ]),
    requiredList() {
      let {requiredItems} = this.regInfo;
      if ( requiredItems) {
        if(this.loginType === 1) return ['用户名',...JSON.parse(requiredItems)]
        return JSON.parse(requiredItems)
      }
      return [];
    },
    showList() {
      let {showItems} = this.regInfo;
      if ( showItems ) {
        let publicArray = [];
        if(showItems.includes('性别')) publicArray.push('性别')
        if(this.loginType === 1) return ['用户名',...JSON.parse(showItems),...publicArray]
        let resultShowList = ['手机号','用户名']
        if(showItems.includes('组别')) resultShowList.push('组别')
        if(showItems.includes('地区')) resultShowList.push('地区')
        if(showItems.includes('证件类型')) resultShowList.push('证件类型')
        return [...resultShowList,...publicArray]
      }
      return [];
    },
    showExtItems() {
      let {extItems} = this.regInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.isShow)
      }
      return [];
    },
    requiredExtItems() {
      let {extItems} = this.regInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.required)
      }
      return [];
    },
    groups() {
      let {groups} = this.regInfo;
      if ( groups) {
        return groups
      }
      return [];
    },
    setBackColor(){
      return {
        'backgroundColor':this.globalConfig.bg.value,
      }
    },
    setColorStyle(){
      return{
        color:this.globalConfig.main,
      }
    },
    setBgBtnColor(){
      return{
        backgroundColor:this.globalConfig.vice,
        color:this.globalConfig.main,
      }
    },
    getStyle(){
      return {
        'background-image':'url(http://cdn.xiaohoucode.com/'+this.certificateInfo.bgUrl+')',
      }
    },
    toggleCertificate(){
      return Number(this.id) !== 118
    }
  },
  methods: {
    ...mapActions(['setSmsSend','setRegDiaLog']),
    setProcessName(name){
      if((Number(this.id) !== 127 && Number(this.id) !== 44)) return name;
      if(name === '初赛') return '证书';
      if(name === '复赛') return '证书一';
      if(name === '决赛') return '证书二';
    },
    toggleTip(item,val){
      item.isTip = val
    },
    async regSucces({info,userType}) {
      try {
        const {data} = await updateStudentInfo(info)
        if(data){
          if(userType === 'edit') {
            this.$message.showMessage({info: '更新成功'})
            this.regClose()
            if(this.loginStatus){
              if(this.loginType === 2){
                let params = {...this.userInfo,username:info.name}
                this.$store.dispatch('saveUserInfo', params)
              }
              // setTimeout(() => {
              //   window.location.reload()
              // },500);
            }
            this.$router.push('/')
            
          }
        }
      } catch ({ data }) {
        errorHandler(data);
      }
      

    },
    registClose(){
      this.regClose()
    },
    regClose() {
      this.dialogVisible = false;
      this.setRegDiaLog(false)
      this.$emit('regClose')
    },
    isShowEditUserInfo(){
      this.dialogVisible = true;
    },
    async getStudentInfo(){
      const {data} = await getStudentInfo(this.id)
      this.currentUserInfo = {...this.userInfo,...data}
      let isHasRegInfo = false;
      try {
          const res = await getRegInfo(this.id)
          this.regInfo = res.data;
          isHasRegInfo = true;
      } catch (error) {
        isHasRegInfo = false;
        errorHandler(error.data)
      }
      if(data && isHasRegInfo) this.isShowInfo = true;
    },
    goBack(){
      this.$router.push({
        path:'/'
      })
    },
    close(){
      this.setSmsSend(false)
    },
    onSuccess(){
      this.setSmsSend(false)
    },
    async handleTicketBtn(val,processId) {
      if(val.isLoading) return;
      val.isLoading = true;
      if(this.websiteTime > downLoadTickeTimer){
        try {
          let res = await getPdfTicketDownload({
            processId
          });
          await download(res,'application/pdf;charset=utf-8',val.ticketName)
          val.isLoading = false
        } catch (error) {
          val.isLoading = false
        }
        return;
      }
      this.currentTicketConent = { ...val }
      this.$nextTick(() => {
        html2canvas(this.$refs.ticket.$el, {
          allowTaint: true,
          useCORS: true,
        })
          .then((canvas) => {
            this.fileDownload(canvas.toDataURL('image/png'), val.ticketName);
            val.isLoading = false;
          });
      });    
    },

    async handleCertBtn(val,processId) {
      if(val.isLoading) return;
      val.isLoading = true;
      if(this.websiteTime > downLoadTimer){
        try {
          let res = await getPdfDownload({
            processId
          });
          await download(res,'application/pdf;charset=utf-8',val.studentName)
          val.isLoading = false
        } catch (error) {
          val.isLoading = false
        }
        return;
      }
      this.currentCertificateContent = { ...val }
      this.$nextTick(() => {
        html2canvas(this.$refs.certificate.$el, {
          allowTaint: true,
          useCORS: true,
        })
          .then((canvas) => {
            this.fileDownload(canvas.toDataURL('image/png'), val.studentName);
            val.isLoading = false;
          });
      });
    },

    fileDownload(downloadUrl, filename) {
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = downloadUrl;
      aLink.download = `${filename}.png` || "竞赛.png";
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },

    getCpProcess() {
      getCpProcess({ competitionId: this.id })
        .then(res =>{
          const paramse = res.data;
          let buttons = this.certificateInfo.buttons;
          paramse.map(item=>{
            buttons.map(tag=>{
              if(item.certificateContent && tag.name === 'certificate'){
                item.certificateContent.url = tag.url
                item.certificateContent.hoverUrl = tag.hoverUrl
                item.certificateUrl = tag.url
                item.certificateContent.isLoading = false
                item.certificateContent.isTip = false
              }else if(item.ticketContent && tag.name === 'ticket'){
                item.ticketContent.url = tag.url
                item.ticketContent.hoverUrl = tag.hoverUrl
                item.ticketUrl = tag.url
                item.ticketContent.isLoading = false
              }
            })
          })
          this.process = paramse;
          if(this.process.length){
            this.isInfoEdit = this.process.filter(item=>item.type === 0)[0].allowInfoEdit;
          }
          
        });
    },
    // getTicketUrl(item,url){
    //   this._preloadImg(item,'ticketUrl',url)
    // },
    // getCertificateUrl(item,url){
    //   this._preloadImg(item,'certificateUrl',url)
    // },
    // setUrl(url){
    //   return `http://cdn.xiaohoucode.com/${url}`
    // },
    _preloadImg(item,key,url){
        const img = new Image();
        img.onload = function() {
            item[key] = url
        };
       item[key] = url
    }


  },

  created() {
    this.getCpProcess();
    this.getStudentInfo()
    this.currentName = this.$route.name;
  }
}

</script>
<style lang="less" scoped>
@import "~@/assets/less/mixin.less";
.cp_flow{
  min-height: 100%;
}
.tip{
  position: absolute;
  top:52px;
  left:20px;
  width: 280px;
  &__arrow{
    position: absolute;
    top: -5px;
    left: 28px;
    display: inline-block;
    width: 10px;
    height: 10px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: #fff;
    z-index: 2;
  }
  &__text{
    // display: none;
    padding: 0;
    margin: 0;
    padding:12px 14px;
    background: #fff;
    border-radius: 10px;
    font-size: 10px;
    box-shadow:0px 0px 5px 0px rgba(180,180,180,0.53);
    position: relative;
    z-index: 1;
    color:#333;
  }
}
.flow {
  &__banner {
   
    width: 100%;
    height:216px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    &__cen{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      position: relative;
    }
   
    &__content{
      width: 1000px;
      height:216px;
      margin:0 auto;
      position: absolute;
    }
    .back{
      position: absolute;
      top:50%;
      left:0;
      width: 86px;
      height: 44px;
      text-align: center;
      left: 34px;
      display: flex;
      border-radius: 20px;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      transition:all .1s ease;
      .back_text{
        margin-left:3px;
      }
      &:hover{
        transform: scale(1.1);
      }
    }
  }

  &__title {
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    width: 560px;
    height: 79px;
    .bg-img("~@/assets/zsxj");
    background-color: #624725;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 239px 48px;
    border: 3px solid #50331A;
    border-radius: 15px;

    &::after {
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 6px solid #F7C940;
      border-radius: 12px;
    }
  }

  &__main {
    // padding-bottom: 50px;
    // background-color: #fff;
    // position: relative;
   &__content{
     width: 1000px;
     min-height: 256px;
     margin:0 auto;
     padding-top:40px;
    //  background: #fff;
    //  box-shadow:0px 2px 8px 0px rgba(185,185,185,0.38);
    //  border-radius: 4px;
    //  position: absolute;
    //  top:-44px;
    //  left:50%;
    //  transform: translate(-50%,0);
    }
  }

  &__steps {
    width: 860px;
    margin: 0 auto;
  }
}
.step__desc {
  display: flex;
  align-items: center;
  margin-bottom: 40px;

  &__left {
    width: 532px;
    font-size: 16px;
    // color:#666;

  }
  &__addon {
    flex: 1;
    display: flex;
  }
  .certificate__content{
      position: relative;
    }
  &__button {
    margin-left: 20px;
    display: inline-block;
    width: 128px;
    height: 40px;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    background-size: 100%;
    background-position:center;
    background-repeat: no-repeat;
    font-size: 14px;
    font-weight: 500;
    transition:all .1s ease;
    &.certificate{
      width: 100px;
      position: relative;
      text-align: left;
      padding-left: 22px;
      &.certificate__loading{
        padding-left:14px
      }
    }
    &.ticket__btn{
      position: relative;
      text-align: left;
      padding-left:22px;
      &.ticket__loading{
        padding-left:14px
      }
    }
    &:hover{
      transform: scale(1.1);
    }
  }
}
.certs {
  position: fixed;
  top: -9999px;
  left: -9999px;
  // width: 3520px;
  // height: 2351px;
}
.ticket {
  position: fixed;
  top: -9999px;
  left: -9999px;
}
.process_name{
  font-size: 18px;
  // color:#333;
}
.dialog{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left:0;
	z-index: 99;
	background-color:rgba(12,12,12,.616);
	color: #333;
	.dialog_content{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width:562px;
		background:#fff;
		border-radius:6px;
    box-shadow: border-box;
		.header{
			position: relative;
			.header_title{
				text-align: center;
				padding:25px 0 0;
				font-size:24px;
				color:#333;
				margin:0;
			}
			.header_title_close{
				position: absolute;
				top:10px;
				right:10px;
				width:18px;
				height: 18px;
				text-align: center;
				line-height: 18px;
				color:#333;
				margin:0;
				font-size: 24px;
        cursor: pointer;
        background: url('~@/assets/competition_close.png') no-repeat;
        background-size: 100% 100%;
			}
    }
	}
	.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>
